import React, { memo } from 'react';
import {
  Button,
  DialogContentText
} from '@mui/material';
import BaseModal from './common/BaseModal';

const ConfirmationDialog = memo(({
  open,
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  isLoading = false
}) => {
  // Handle both close button and cancel button clicks
  const handleClose = () => {
    if (onCancel) {
      onCancel();
    }
  };

  const actions = (
    <>
      <Button 
        onClick={(e) => {
          e.stopPropagation();
          handleClose();
        }} 
        variant="outlined"
        disabled={isLoading}
        sx={{ 
          textTransform: 'none',
          minWidth: { xs: 'auto', sm: '100px' }
        }}
      >
        {cancelText}
      </Button>
      <Button 
        onClick={(e) => {
          e.stopPropagation();
          if (onConfirm) onConfirm();
        }} 
        variant="contained"
        color="error"
        disabled={isLoading}
        sx={{ 
          textTransform: 'none',
          minWidth: { xs: 'auto', sm: '100px' }
        }}
      >
        {isLoading ? 'Processing...' : confirmText}
      </Button>
    </>
  );

  return (
    <BaseModal
      open={open}
      onClose={handleClose}
      title={title}
      size="small"
      maxWidth="xs"
      actions={actions}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
    >
      <DialogContentText id="confirmation-dialog-description">
        {message}
      </DialogContentText>
    </BaseModal>
  );
});

ConfirmationDialog.displayName = 'ConfirmationDialog';

export default ConfirmationDialog; 